module.exports = __webpack_public_path__ + "img/灵活的数据应用能力.5128e0ca.png";